import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Plaid from '../../components/Plaid';
import Progress from '../../components/Progress';
import {
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';

import './style.scss';

const FindBank = (props) => {
  const config = useConfig();
  const { checkinData, navigate, params, searchParams } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(false);
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;
    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [checkinData]);

  const handleVerifyLater = () => {
    const { dispatch } = props;

    dispatch(newNextAction({
      key,
      workflowType: workflowType || 'text2apply',
      data: {
        isPlaidComplete: false,
      },
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  const handlePlaidSuccess = (sessionId) => {
    const { dispatch } = props;

    setIsProgressVisible(true);

    dispatch(newNextAction({
      key,
      workflowType: workflowType || 'text2apply',
      data: {
        isPlaidComplete: true,
        plaidSessionId: sessionId,
      },
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  const handlePlaidExit = () => {
    const { dispatch } = props;
    setIsProgressVisible(true);

    dispatch(newNextAction({
      key,
      workflowType: workflowType || 'text2apply',
      data: {
        isPlaidComplete: false,
      },
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  return (
    <>
      <div className="plaidContainer">
        <Plaid
          onPlaidSuccess={handlePlaidSuccess}
          onPlaidExit={handlePlaidExit}
        />
        {
          isProgressVisible && <Progress percent={uploadingPercentage} />
        }
      </div>
      <div className="verifyLater" onClick={handleVerifyLater}>Verify later</div>
    </>
  );
};

FindBank.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(FindBank);
